// Generated by purs version 0.15.15
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Ouroboros_Models_Brands_Milliseconds from "../Ouroboros.Models.Brands.Milliseconds/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var dayMs = /* #__PURE__ */ (function () {
    return 1000.0 * 60.0 * 60.0 * 24.0;
})();
var daysAgo = function (nowMs) {
    return function (lastEditedMs) {
        return Data_Int.floor((nowMs - Ouroboros_Models_Brands_Milliseconds.unwrap(lastEditedMs)) / dayMs);
    };
};
var categorizeDocumentsByAge = function (nowMs) {
    return function (documents) {
        var editedWithin7Days = map(function (v) {
            return v.doc;
        })(Data_Array.filter(function (item) {
            return daysAgo(nowMs)(item.lastEditedMs) <= 7;
        })(documents));
        var editedWithin30Days = map(function (v) {
            return v.doc;
        })(Data_Array.filter(function (item) {
            var age = daysAgo(nowMs)(item.lastEditedMs);
            return age > 7 && age <= 30;
        })(documents));
        var editedBefore30Days = map(function (v) {
            return v.doc;
        })(Data_Array.filter(function (item) {
            return daysAgo(nowMs)(item.lastEditedMs) > 30;
        })(documents));
        return {
            editedWithin7Days: editedWithin7Days,
            editedWithin30Days: editedWithin30Days,
            editedBefore30Days: editedBefore30Days
        };
    };
};
export {
    categorizeDocumentsByAge
};
//# sourceMappingURL=index.js.map
